import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Dumbbell, ChevronUp, ChevronDown } from 'lucide-react'
import { SessionCard } from './SessionCard'
import { isSessionUpcoming } from './corporate-helpers'

export const ProgramSection = ({ program, sessions, onSelectSession }) => {
    const [isExpanded, setIsExpanded] = useState(true)
    const programSessions = sessions.filter(s => s.programId === program.programId)
    const upcomingSessions = programSessions.filter(s => isSessionUpcoming(s.sessionDate))

    return (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-full flex items-center gap-3 px-4 py-3.5 hover:bg-gray-50 transition-colors"
            >
                <div className="w-9 h-9 rounded-xl bg-linear-to-br from-indigo-500 to-violet-500 flex items-center justify-center shrink-0">
                    <Dumbbell size={16} className="text-white" />
                </div>
                <div className="flex-1 min-w-0 text-left">
                    <p className="text-sm font-bold text-gray-900 truncate">{program.programName || `Program #${program.programId}`}</p>
                    <p className="text-[11px] text-gray-500">
                        {program.programType && <span className="capitalize">{program.programType} · </span>}
                        {upcomingSessions.length} upcoming session{upcomingSessions.length !== 1 ? 's' : ''}
                    </p>
                </div>
                {isExpanded ? <ChevronUp size={16} className="text-gray-400" /> : <ChevronDown size={16} className="text-gray-400" />}
            </button>

            <AnimatePresence>
                {isExpanded && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        className="overflow-hidden"
                    >
                        <div className="px-4 pb-4 space-y-2">
                            {programSessions.length === 0 ? (
                                <p className="text-center text-sm text-gray-400 py-4">No sessions scheduled yet</p>
                            ) : (
                                programSessions.map((session, idx) => (
                                    <SessionCard key={session.id || idx} session={session} onSelect={onSelectSession} />
                                ))
                            )}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}
